import * as React from 'react';



export default class ToastSuccess extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <g stroke="#5FBB80">
                <g>
                    <g transform="translate(-391.000000, -718.000000) translate(381.000000, 709.000000) translate(10.000000, 9.000000)">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M8 11.915L10.622 14.536 16.158 9"/>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
